import { templateStudioStateService } from 'state/template-studio.state.service';

import { useObservable } from '../observable';

export const useTemplateStudioState = () => {
  const openSidebarBlock = useObservable(
    templateStudioStateService.openSidebarBlock
  );
  const hiddenBlocks = useObservable(templateStudioStateService.hiddenBlocks);
  const previewDeviceLayout = useObservable(
    templateStudioStateService.previewDeviceLayout
  );
  const templateIdToActivate = useObservable(
    templateStudioStateService.templateIdToActivate
  );
  const templateIdToDelete = useObservable(
    templateStudioStateService.templateIdToDelete
  );
  const currentCompany = useObservable(
    templateStudioStateService.currentCompany
  );
  const defaultBodyBlocksOrder = useObservable(
    templateStudioStateService.defaultBodyBlocksOrder
  );
  const supportedThemes = useObservable(
    templateStudioStateService.supportedThemes
  );
  const relevantBundleDesigns = useObservable(
    templateStudioStateService.relevantBundleDesigns
  );
  const displayPopupPreview = useObservable(
    templateStudioStateService.displayPopupPreview
  );
  const relevantPromotionDesigns = useObservable(
    templateStudioStateService.relevantPromotionDesigns
  );
  const relevantRollingOffersDesigns = useObservable(
    templateStudioStateService.relevantRollingOffersDesigns
  );
  const scrollToSection = useObservable(
    templateStudioStateService.scrollToSection
  );

  return {
    openSidebarBlock,
    setOpenSidebarBlock: templateStudioStateService.setOpenSidebarBlock,
    hiddenBlocks,
    toggleBlockVisibility: templateStudioStateService.toggleBlockVisibility,
    isBlockHidden: templateStudioStateService.isBlockHidden,
    previewDeviceLayout,
    togglePreviewDeviceLayout:
      templateStudioStateService.togglePreviewDeviceLayout,
    templateIdToActivate,
    setTemplateIdToActivate: templateStudioStateService.setTemplateIdToActivate,
    templateIdToDelete,
    setTemplateIdToDelete: templateStudioStateService.setTemplateIdToDelete,
    currentCompany,
    setCurrentCompany: templateStudioStateService.setCurrentCompany,
    defaultBodyBlocksOrder,
    setDefaultBodyBlocksOrder:
      templateStudioStateService.setDefaultBodyBlocksOrder,
    displayPopupPreview,
    setDisplayPopupPreview: templateStudioStateService.setDisplayPopupPreview,
    supportedThemes,
    setSupportedThemes: templateStudioStateService.setSupportedThemes,
    relevantBundleDesigns,
    setRelevantBundleDesigns:
      templateStudioStateService.setRelevantBundleDesigns,
    relevantPromotionDesigns,
    setRelevantPromotionDesigns:
      templateStudioStateService.setRelevantPromotionDesigns,
    relevantRollingOffersDesigns,
    setRelevantRollingOffersDesigns:
      templateStudioStateService.setRelevantRollingOffersDesigns,
    scrollToSection,
    setScrollToSection: templateStudioStateService.setScrollToSection
  };
};
